import ResetPassword from '@/components/authentication/ResetPassword';

export const Route = createFileRoute({
	component: ResetPassword,
	validateSearch: (search) => {
		return {
			token: search.token as string,
			email: search.email as string,
		};
	},
});
